import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { mdiWhatsapp, mdiEmailOutline, mdiInstagram } from "@mdi/js";
import Icon from "@mdi/react";
import { motion } from "framer-motion";

import { ColorsStyle } from "../../config/colors";

declare const window: Window & { dataLayer: Record<string, unknown>[] };

export default function LandingContato(){

	return (
		<Container fluid id="contato" className="py-5 position-relative" >
			<Container>
				<Row>
					<Col md={{span: 7}} className="d-flex flex-column align-items-start" style={{zIndex: 2}}>
						<div className="mb-4 fs-1 text-white fw-bold">Evolua sua barbearia agora mesmo</div>
						<div className="mb-4 fs-5">Entre em contato através do WhatsApp da Tribo, nossa equipe está pronta para lhe atender</div>
						<motion.a whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} onClick={()=>{ window.dataLayer.push({ event: 'contato' }); }} href="https://api.whatsapp.com/send?phone=5551998984048" target="_blank" className="mb-2 fs-6 d-flex align-items-center text-decoration-none cursor-pointer text-white">
							<Icon path={mdiWhatsapp} size={1} className="me-2" style={{color: "#25D366"}}/> 55 (51) 99898-4048
						</motion.a>
						<motion.a whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} onClick={()=>{ window.dataLayer.push({ event: 'contato' }); }} href="https://www.instagram.com/tribobarberapp/" target="_blank" className="mb-2 fs-6 d-flex align-items-center text-decoration-none cursor-pointer text-white">
							<svg width="0" height="0">
								<linearGradient id="blue-gradient" x1="0%" y1="100%" x2="100%" y2="0%">
									<stop stopColor="#f09433" offset="0%" />
									<stop stopColor="#e6683c" offset="25%" />
									<stop stopColor="#dc2743" offset="50%" />
									<stop stopColor="#cc2366" offset="75%" />
									<stop stopColor="#833AB4" offset="100%" />
									833AB4
								</linearGradient>
							</svg>
							<Icon path={mdiInstagram} size={1} className="me-2" color={"url(#blue-gradient)"}/> @tribobarberapp
						</motion.a>
						<motion.a whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} onClick={()=>{ window.dataLayer.push({ event: 'contato' }); }} href="mailto:desenvolvimento@tribobarber.com.br" target="_blank" className="mb-4 fs-6 d-flex align-items-center text-decoration-none cursor-pointer text-white">
							<Icon path={mdiEmailOutline} size={1} className="me-2"/> desenvolvimento@tribobarber.com.br
						</motion.a>
						<motion.a whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} onClick={()=>{ window.dataLayer.push({ event: 'contato' }); }} href="https://api.whatsapp.com/send?phone=5551998984048" target="_blank">
							<Button size="lg" className="px-4 py-3 fw-medium">Fale com um especialista</Button>
						</motion.a>
					</Col>
					<Col className="position-relative">
						<div className="position-absolute" style={{inset: 0, zIndex: 0, background: `linear-gradient(0deg, transparent 75%, ${ColorsStyle.Grey800})`}} />
						<div className="position-absolute" style={{inset: 0, zIndex: 0, background: `linear-gradient(270deg, transparent 75%, ${ColorsStyle.Grey800})`}} />
						<div className="position-absolute" style={{inset: 0, zIndex: 0, background: `linear-gradient(180deg, transparent 75%, ${ColorsStyle.Grey800})`}} />
						<div className="position-absolute" style={{inset: 0, zIndex: 0, background: `linear-gradient(90deg, transparent 75%, ${ColorsStyle.Grey800})`}} />
						<Image src={process.env.PUBLIC_URL + "contato.webp"} loading="lazy" alt="Barbeiros Aperto de Mãos" className="mb-4 object-fit-cover" style={{width: "100%", height: "100%", objectPosition: "center center"}}/>
					</Col>
				</Row>
			</Container>
		</Container>
	)
}